<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { sessionHelper, filtersHelper } from "@/utils";
import { SESSION } from "@/constants";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { PRODUCT_MODULE } from '@/state/modules/product'
import { productMethods } from "@/state/helpers";
/**
 * Tabs & accordions component
 */
export default {
    page: {
        title: i18n.t("label.xDetail", [i18n.t("module.product")]),
    },
    components: {
        Layout, PageHeader
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-listing" && to.name != "Product-ai-update" && to.name != "Product-ai-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_MODULE, ["status"]),
        data() {
            return this.$store.state.product.details;
        },
        helper() { return filtersHelper; },
        productQuerySorted() {
            return (this.data.productQuery || []).slice().sort((a, b) => {
                const da = new Date(a.date || 0).getTime();
                const db = new Date(b.date || 0).getTime();
                return db - da;
            });
        },
        printerProofSorted() {
            return (this.data.productPrinterProof || []).slice().sort((a, b) => {
                const da = new Date(a.date || 0).getTime();
                const db = new Date(b.date || 0).getTime();
                return db - da;
            });
        },
        productPaymentSorted() {
            return (this.data.productPayment || []).slice().sort((a, b) => {
                const da = new Date(a.date || 0).getTime();
                const db = new Date(b.date || 0).getTime();
                return db - da;
            });
        },
        recommendationsSorted() {
            return (this.data && this.data.productRecommendation) ? this.data.productRecommendation : [];
        },
    },
    data() {
        return {
            title: i18n.t("label.xDetail", [i18n.t("module.product")]),
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.product"),
                    href: "/product",
                },
                {
                    text: i18n.t("label.xDetail", [i18n.t('module.product')]),
                    active: true,
                },
            ],
            submitted: false,
            productID: '',
        };
    },
    async created() {
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH);

        this.getProductData();
    },
    methods: {
        ...productMethods,
        async getProductData() {
            this.isLoading = true;
            await this.getProduct({ id: this.searchCriteria.selectedRecordId });
            this.isLoading = false;
            this.productID = this.searchCriteria.selectedRecordId;
        },
        getVariant(expiredDate) {
            if (!expiredDate) return 'secondary'; // fallback if date is missing

            const today = new Date();
            const expiry = new Date(expiredDate);
            const diffTime = expiry - today;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays < 0) {
                return 'danger'; // expired
            } else if (diffDays <= 183) { // ~6 months
                return 'yellow'; // expiring within 6 months
            } else {
                return 'primary'; // valid
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card" style="margin: 10px; border-radius: 10px;">
                    <div class="card-body">
                        <div class="row" style="margin: 10px;">
                            <h4 class="mb-0">{{ data.brandName }}</h4>
                            <b-badge :variant="getVariant(data.formatExpiredDate)"
                                class="d-inline-flex align-items-center justify-content-center text-center px-2 py-1"
                                style="margin-left: 10px; margin-right: 10px;">
                                {{ data.formatExpiredDate }}
                            </b-badge>
                            <b-badge variant="primary"
                                class="d-inline-flex align-items-center justify-content-center text-center px-2 py-1"
                                v-if="data.status.uuid != '58380ab4-67a4-40ee-9860-7d5ba78f965f'">
                                {{ data.status.name }}
                            </b-badge>
                            <b-badge variant="warning"
                                class="d-inline-flex align-items-center justify-content-center text-center px-2 py-1"
                                v-else>
                                {{ data.status.name }}
                            </b-badge>
                        </div>
                        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
                            <div v-for="(item, index) in [
                                { label: $t('module.company'), value: data.companyID.text },
                                { label: $t('module.form'), value: data.formulationID.text },
                                { label: $t('module.type'), value: data.typeID.text },
                                { label: $t('module.class'), value: data.classID.text },
                            ]" :key="index" class="col">
                                <div class="border rounded-3 p-3 h-100 text-center bg-light">
                                    <p class="text-muted small mb-1">{{ item.label }}</p>
                                    <h5 class="fw-bold mb-0">{{ item.value }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="row g-4 gy-3" style="margin: 10px;">
                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.name')" label-for="name">
                                    <b-form-input id="name" v-model.trim="data.brandName"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.lrmp')" label-for="lrmp">
                                    <b-form-input id="lrmp" v-model.trim="data.lrmp"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.XreferenceNumber', [$t('module.product')])"
                                    label-for="referenceNumber">
                                    <b-form-input id="referenceNumber"
                                        v-model.trim="data.referenceNumber"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.dor')" label-for="dor">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <i class="mdi mdi-calendar"></i>
                                        </b-input-group-prepend>
                                        <b-form-input id="dor" v-model.trim="data.formatDOR"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.doe')" label-for="expiredDate">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <i class="mdi mdi-calendar"></i>
                                        </b-input-group-prepend>
                                        <b-form-input id="expiredDate" v-model.trim="data.formatExpiredDate"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.dorSubmissionDate')" label-for="dorSubmissionDate">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <i class="mdi mdi-calendar"></i>
                                        </b-input-group-prepend>
                                        <b-form-input id="dorSubmissionDate"
                                            v-model.trim="data.formatDossierSubmissionDate"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.approvalDate')" label-for="approvalDate">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <i class="mdi mdi-calendar"></i>
                                        </b-input-group-prepend>
                                        <b-form-input id="approvalDate" v-model.trim="data.formatApprovalDate"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.status')" label-for="status">
                                    <b-form-input id="lrmp" v-model.trim="data.statusID.text"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.purpose')" label-for="purpose">
                                    <!-- If you have options: b-form-select -->
                                    <b-form-input id="purpose" v-model.trim="data.purposeID.text"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group label-cols-sm="4" label-class="fw-medium text-muted"
                                    :label="$t('label.shelfLifeTimeYear')" label-for="shelfLifeTimeYear">
                                    <b-form-input id="shelfLifeTimeYear"
                                        v-model.trim="data.shelfLifeTime.name"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-12">
                                <b-form-group label-cols-sm="2" label-class="fw-medium text-muted"
                                    :label="$t('label.remark')" label-for="remark">
                                    <b-form-textarea id="remark" v-model="data.remark" rows="4"></b-form-textarea>
                                </b-form-group>
                            </div>

                            <div class="col-lg-12 d-flex align-items-center justify-content-end">
                                <b-form-checkbox id="isRegisterCert" v-model="data.isRegisterCert" :value="true"
                                    :unchecked-value="false" switch>
                                    {{ $t('label.isRegisterCert') }}
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card border-0 rounded-3 shadow-sm m-3">
                    <div class="card-body" style="padding: 10px;">
                        <!-- 2-up layout -->
                        <div class="row g-4" style="margin: 10px;">
                            <!-- Left table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('label.endorseLabel') }}</h6>

                                        <div class="table-responsive">
                                            <table
                                                class="table table-sm table-striped table-hover align-middle mb-0 tile-table">
                                                <thead class="table-light sticky-top">
                                                    <tr>
                                                        <th style="width:64px" class="text-muted">#</th>
                                                        <th>{{ $t('label.endorseLabel') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="data.endorseLabelArray.length > 0">
                                                    <tr v-for="(u, i) in data.endorseLabelArray" :key="u.id || i">
                                                        <th scope="row">{{ i + 1 }}</th>
                                                        <td>{{ u }}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="2" class="text-center py-4 text-muted">
                                                            {{ $t('message.noDataFound') }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.productAI') }}</h6>

                                        <div class="table-responsive">
                                            <table
                                                class="table table-sm table-striped table-hover align-middle mb-0 tile-table">
                                                <thead class="table-light sticky-top">
                                                    <tr>
                                                        <th style="width:64px" class="text-muted">#</th>
                                                        <th>{{ $t('module.activeIngredient') }}</th>
                                                        <th>{{ $t('label.concentration') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="data.productAI.length > 0">
                                                    <tr v-for="(u, i) in data.productAI" :key="u.id || i">
                                                        <th scope="row">{{ i + 1 }}</th>
                                                        <td>{{ u.rnd_active_ingredient.name }}</td>
                                                        <td>{{ u.concentration }}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="4" class="text-center py-4 text-muted">
                                                            {{ $t('message.noDataFound') }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row g-4" style="margin: 10px;">
                            <!-- Left table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.productSource') }}</h6>

                                        <div class="table-responsive">
                                            <table
                                                class="table table-sm table-striped table-hover align-middle mb-0 tile-table">
                                                <thead class="table-light sticky-top">
                                                    <tr>
                                                        <th style="width:64px" class="text-muted">#</th>
                                                        <th>{{ $t('module.source') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="data.productSource.length > 0">
                                                    <tr v-for="(u, i) in data.productSource" :key="u.id || i">
                                                        <th scope="row">{{ i + 1 }}</th>
                                                        <td>{{ u.source.name }}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="2" class="text-center py-4 text-muted">
                                                            {{ $t('message.noDataFound') }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.query') }}</h6>
                                        <div v-if="productQuerySorted.length" class="timeline">
                                            <div v-for="(u, i) in productQuerySorted" :key="u.id || i" class="tl-item">
                                                <div class="tl-content">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <span class="badge"
                                                            :class="u.type === 1 ? 'badge-warning-soft' : 'badge-success-soft'">
                                                            {{ u.type === 1 ? 'Query' : 'Reply' }}
                                                        </span>
                                                        <small class="text-muted">{{
                                                            helper.getDateFormat(u.date) }}</small>
                                                    </div>

                                                    <!-- Optional message/remark if you have one -->
                                                    <div v-if="u.remark && u.remark != 'NULL'" class="mt-1 text-muted">
                                                        {{ u.remark }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-4 text-muted">
                                            {{ $t('message.noDataFound') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-4" style="margin: 10px;">
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.printerProof') }}</h6>
                                        <div v-if="printerProofSorted.length" class="timeline">
                                            <div v-for="(u, i) in printerProofSorted" :key="u.id || i" class="tl-item">
                                                <div class="tl-content">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <span class="badge"
                                                            :class="u.type === 1 ? 'badge-warning-soft' : 'badge-success-soft'">
                                                            {{ u.type === 1 ? 'Query' : 'Reply' }}
                                                        </span>
                                                        <small class="text-muted">{{
                                                            helper.getDateFormat(u.date) }}</small>
                                                    </div>

                                                    <!-- Optional message/remark if you have one -->
                                                    <div v-if="u.remark && u.remark != 'NULL'" class="mt-1 text-muted">
                                                        {{ u.remark }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-4 text-muted">
                                            {{ $t('message.noDataFound') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.productPayment') }}</h6>
                                        <div v-if="productPaymentSorted.length" class="timeline">
                                            <div v-for="(u, i) in productPaymentSorted" :key="u.id || i"
                                                class="tl-item">
                                                <div class="tl-content">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <span class="badge"
                                                            :class="u.type === 1 ? 'badge-warning-soft' : 'badge-success-soft'">
                                                            {{ u.type === 1 ? 'Query' : 'Reply' }}
                                                        </span>
                                                        <small class="text-muted">{{
                                                            helper.getDateFormat(u.date) }}</small>
                                                    </div>

                                                    <!-- Optional message/remark if you have one -->
                                                    <div v-if="u.remark && u.remark != 'NULL'" class="mt-1 text-muted">
                                                        {{ u.remark }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-4 text-muted">
                                            {{ $t('message.noDataFound') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-4" style="margin: 10px;">
                            <!-- Left table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.productMoa') }}</h6>

                                        <div class="table-responsive">
                                            <table
                                                class="table table-sm table-striped table-hover align-middle mb-0 tile-table">
                                                <thead class="table-light sticky-top">
                                                    <tr>
                                                        <th style="width:64px" class="text-muted">#</th>
                                                        <th>{{ $t('module.moa') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="data.rndProductMoa.length > 0">
                                                    <tr v-for="(u, i) in data.rndProductMoa" :key="u.id || i">
                                                        <th scope="row">{{ i + 1 }}</th>
                                                        <td>{{ u.moa.name }}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="2" class="text-center py-4 text-muted">
                                                            {{ $t('message.noDataFound') }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.productLabel') }}</h6>

                                        <div class="table-responsive">
                                            <table
                                                class="table table-sm table-striped table-hover align-middle mb-0 tile-table">
                                                <thead class="table-light sticky-top">
                                                    <tr>
                                                        <th style="width: 30px" class="text-muted">#</th>
                                                        <th>{{ $t('label.date') }}</th>
                                                        <th>{{ $t('label.packageSize') }}</th>
                                                        <th>{{ $t('label.packagingMaterial') }}</th>
                                                        <th>{{ $t('label.remark') }}</th>
                                                        <th>{{ $t('label.image') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody
                                                    v-for="(item, index) in data.rndProductNewLabels"
                                                    :key="index"
                                                >
                                                    <tr
                                                        v-for="(u, i) in item.labels"
                                                        :key="i"
                                                    >
                                                        <td scope="row">
                                                            {{ data.rndProductNewLabels.slice(0, index).reduce((sum, prev) => sum + prev.labels.length, 0) + i + 1 }}
                                                        </td>
                                                        <td>{{ item.date }}</td>
                                                        <td>{{ u.size }}</td>
                                                        <td>{{ u.packagingMaterial }}</td>
                                                        <td>{{ u.remark }}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="btn btn-primary btn-sm"
                                                                v-on:click="$bvModal.show('product_labels_image_modal_'+u.uuid)">
                                                                {{ $t('label.viewX', []) }} <b-badge v-if="u.images.length > 0" variant="light">{{ u.images.length }}</b-badge>
                                                            </button>
                                                            <b-modal
                                                                :id="'product_labels_image_modal_'+u.uuid"
                                                                :title="$t('label.image')"
                                                                size="lg"
                                                                centered
                                                                hide-header-close
                                                            >
                                                                <div class="row">
                                                                    <div v-for="(img, imgIndex) in u.images" :key="imgIndex" class="col-4 mb-2">
                                                                        <a :href="img.imageUrl" target="_blank" class="cursor-pointer">
                                                                            <img
                                                                                :src="img.imageUrl"
                                                                                class="img-thumbnail img-fluid"
                                                                                style="width: 100%; aspect-ratio: 1 / 1; object-fit: cover; border-radius: 4px;"
                                                                                :title="$t('label.viewX', [])"
                                                                            >
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                <template #modal-footer>
                                                                    <b-button variant="secondary" v-on:click="$bvModal.hide('product_labels_image_modal_'+u.uuid)">
                                                                        {{ $t('label.cancel') }}
                                                                    </b-button>
                                                                </template>
                                                            </b-modal>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-if="data.rndProductNewLabels.length == 0">
                                                    <tr>
                                                        <td colspan="10" class="text-center py-4 text-muted">
                                                            {{ $t('message.noDataFound') }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row g-4" style="margin: 10px;">
                            <!-- Left table -->
                            <div class="col-12 col-lg-6">
                                <div class="tile card h-100">
                                    <div class="card-body">
                                        <h6 class="tile-title mb-3">{{ $t('module.productSNS') }}</h6>

                                        <div class="table-responsive">
                                            <table
                                                class="table table-sm table-striped table-hover align-middle mb-0 tile-table">
                                                <thead class="table-light sticky-top">
                                                    <tr>
                                                        <th style="width:64px" class="text-muted">#</th>
                                                        <th>{{ $t('module.productSNS') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="data.productSNS.length > 0">
                                                    <tr v-for="(u, i) in data.productSNS" :key="u.id || i">
                                                        <th scope="row">{{ i + 1 }}</th>
                                                        <td>
                                                            <template v-if="u.image_url">
                                                                <a :href="u.image_url" target="_blank" rel="noopener">
                                                                    {{ $t('label.clickHere') }}
                                                                </a>
                                                            </template>

                                                            <span v-else class="text-muted">
                                                                {{ $t ? $t('message.noImage') : 'No image' }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="2" class="text-center py-4 text-muted">
                                                            {{ $t('message.noDataFound') }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right table -->


                        </div>
                    </div>
                </div>
            </div>

            <!-- RECOMMENDATION (read-only, redesigned) -->
            <div class="col-lg-12 px-3" style="margin: 10px;">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <h6 class="mb-0">{{ $t('module.recommendation') }}</h6>
                </div>

                <div v-if="recommendationsSorted.length">
                    <div v-for="(recommendation, i) in recommendationsSorted" :key="recommendation.id || i"
                        class="rec-card mb-3">
                        <!-- remark + status -->
                        <div class="d-flex align-items-start gap-2 mb-1">
                            <p class="text-muted mb-0 flex-grow-1" v-if="recommendation.remark">{{
                                recommendation.remark}}</p>
                            <div class="ms-auto flex-shrink-0">
                                <b-badge variant="secondary" class="px-2 py-1" v-if="recommendation.status == 0">
                                    {{ $t('label.pending') }}
                                </b-badge>
                                <b-badge variant="primary" class="px-2 py-1" v-else-if="recommendation.status == 1">
                                    {{ $t('label.approve') }}
                                </b-badge>
                            </div>
                        </div>

                        <!-- crops grid -->
                        <div v-if="recommendation.crops && recommendation.crops.length"
                            class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
                            <div v-for="(crop, ci) in recommendation.crops" :key="crop.id || ci" class="col">
                                <div class="crop-tile" style="margin: 10px;">
                                    <!-- Crop title -->
                                    <div class="d-flex align-items-center gap-2 mb-2">
                                        <i class="mdi mdi-leaf text-muted"></i>
                                        <div class="fw-semibold">{{ crop.name }}</div>
                                    </div>

                                    <ul v-if="(crop.pest_controls || []).length" class="pc-list">
                                        <li v-for="(pestControl) in crop.pest_controls" :key="pestControl.id"
                                            class="pc-item">
                                            <span class="pc-name">
                                                <i class="mdi mdi-bug-outline me-1 text-muted"></i>
                                                {{ pestControl.pest_control }}
                                            </span>
                                            <span v-if="pestControl.rate"
                                                class="pc-rate badge bg-light text-dark border">{{
                                                    pestControl.rate }}</span>
                                        </li>
                                    </ul>

                                    <small v-else class="text-muted">{{ $t('message.noDataFound') }}</small>
                                </div>
                            </div>
                        </div>

                        <div v-else class="text-muted small">{{ $t('message.noDataFound') }}</div>
                    </div>
                </div>

                <div v-else class="text-center text-muted py-4">
                    {{ $t('message.noDataFound') }}
                </div>
            </div>




        </div>
    </Layout>
</template>

<style scoped>
.rec-card {
    border: 1px solid #e9ecef;
    border-radius: .75rem;
    padding: 1rem 1.1rem;
    background: #fff;
}

.crop-tile {
    border: 1px solid #e9ecef;
    border-radius: .75rem;
    padding: .9rem 1rem;
    background: #f8f9fb;
}

.pc-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: .5rem;
}

.pc-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .75rem;
    padding: .5rem .65rem;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: .5rem;
}

.pc-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pc-rate {
    flex-shrink: 0;
}

.badge-info-soft {
    background: rgba(13, 110, 253, .12);
    color: #0b5ed7;
    border: 1px solid rgba(13, 110, 253, .25);
    font-weight: 600;
}

.tile {
    border: 1px solid #e9ecef;
    border-radius: .75rem;
    box-shadow: 0 .125rem .5rem rgba(0, 0, 0, .04);
}

.tile-title {
    color: #6c757d;
    font-weight: 600;
    letter-spacing: .2px;
}

.tile-table thead.sticky-top {
    top: 0;
    /* keep header visible when table scrolls */
    z-index: 1;
}

.tile-table th,
.tile-table td {
    padding-top: .6rem;
    padding-bottom: .6rem;
}

.timeline {
    position: relative;
    padding-left: 1.25rem;
    /* space for line + dots */
}

.timeline::before {
    content: "";
    position: absolute;
    left: 12px;
    /* aligns with dot center */
    top: 0;
    bottom: 0;
    width: 2px;
    background: #e9ecef;
    /* soft line */
}

.tl-item {
    position: relative;
    margin-bottom: 1rem;
    padding-left: 1.25rem;
    /* space from dot to content */
}

.tl-dot {
    position: absolute;
    left: 4px;
    /* centers on line (12px) for 16px dot */
    top: 6px;
    /* adjust to align with first line of content */
    width: 16px;
    height: 16px;
    background: #adb5bd;
    /* fallback */
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #e9ecef;
    /* halo against background */
}

.tl-dot-success {
    background: #28a745;
}

.tl-dot-warning {
    background: #ffc107;
}

.tl-content {
    background: #f8f9fb;
    border: 1px solid #e9ecef;
    border-radius: .5rem;
    padding: .75rem .9rem;
}

/* Soft badges to match the card */
.badge-success-soft {
    background: rgba(40, 167, 69, .12);
    color: #2e7d32;
    border: 1px solid rgba(40, 167, 69, .25);
    font-weight: 600;
}

.badge-warning-soft {
    background: rgba(255, 193, 7, .12);
    color: #896300;
    border: 1px solid rgba(255, 193, 7, .25);
    font-weight: 600;
}
</style>